/* ============================================================================== */
/*                    Database file with routing information                      */
/* ============================================================================== */

/*
  -- The IDs of the items are sequential just for uniqueness purposes, in fact the string represents a name, NOT an ordered succession, as order may vary depending on the customer's requirements.
  -- The only naming convetion applied is q - question, r - result.
  -- IDs in checkboxes are needed for routing combination logic (see scripts/scripts.js),
  -------
*/

var questions = [
   {
      id: "q-1",
      question: "Does the study involve human participants?",
      top_text:
         "Unsure how to respond? Our <a href='/policy-and-compliance/policy-topics/human-subjects/research' target='_blank'>Human Subjects Resources</a> and <a href='/faqs#/hs-general-questions.htm' target='_blank'>FAQs</a> may help you decide.",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "q-2",
         },
         {
            id: 2,
            text: "No",
            target: "r-1",
         },
      ],
   },
   {
      id: "q-2",
      question: "Are the participants prospectively assigned* to an intervention**?",
      top_text:
         "Unsure how to respond? <a href='/policy-and-compliance/policy-topics/clinical-trials/definition' target='blank'>Information on our NIH's Definition of a Clinical Trial Webpage</a> may help you decide.",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "q-3",
         },
         {
            id: 2,
            text: "No",
            target: "r-1",
         },
      ],
      bottom_text:
         "<hr /><i><p>* The term prospectively assigned refers to a pre-defined process (e.g., randomization) specified in an approved protocol that stipulates the assignment of research subjects (individually or in clusters) to one or more arms (e.g., intervention, placebo, or other control) of a clinical trial.</p>" +
         "<p>** As related to the definition of a clinical trial, an intervention is defined as both physical procedures by which information or biospecimens are gathered (e.g., venipuncture) and manipulations of the subject or the subject's environment that are performed for research purposes.</p></small>",
   },
   {
      id: "q-3",
      question: "Is the study designed to evaluate the effect of the intervention on the participants?",
      top_text:
         "<p>Remember that an 'intervention' is defined as both physical procedures by which information or biospecimens are gathered (e.g., venipuncture) and manipulations of the subject or the subject's environment that are performed for research purposes.</p>" +
         "<p>Learn more about how to <strong>determine if NIH considers your study to have an intervention</strong> by looking at the <a href='/policy-and-compliance/policy-topics/clinical-trials/definition' target='_blank'>information on the NIH's Definition of a Clinical Trial webpage</a>.</p>",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "q-4",
         },
         {
            id: 2,
            text: "No",
            target: "r-1",
         },
      ],
      bottom_text:
         "",
   },
   {
      id: "q-4",
      question: "Is the effect that will be evaluated a health-related biomedical or behavioral outcome?",
      top_text:
         "<p>Unsure how to respond? <a href='/policy-and-compliance/policy-topics/clinical-trials/definition' target='blank'>Information on our NIH's Definition of a Clinical Trial Webpage</a> may help you decide. Please note that per <a href='/grants/guide/notice-files/NOT-OD-26-032.html'>NOT-OD-26-032</a> for applications submitted for due dates on or after May 25, 2026, NIH no longer characterizes BESH as clinical trials. Please see our webpage on <a href='/policy-and-compliance/policy-topics/clinical-trials/clinical-trial-besh-or-observational-study-involving-humans'>Clinical Trials/BESH/Observational Webpage</a> for further guidance.</p>" +
         "<p><strong>Note</strong>: For application due dates on or after May 25, 2026: Only answer “Yes” if your study's outcome measures have the potential for direct advancement of health (<a href=\"https://grants.nih.gov/grants/guide/notice-files/NOT-OD-26-032.html\">See NOT-OD-26-032</a>).</p>",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "q-5",
         },
         {
            id: 2,
            text: "No",
            target: "r-1",
         },
      ],
      bottom_text: "",
   },
   {
      id: "q-5",
      question: "Are you proposing to work on an ancillary study* (not the parent project)?",
      top_text: "<p>Please see <a href=\"https://grants.nih.gov/faqs#/clinical-trial-definition.htm?anchor=57340\">this FAQ</a> for more information about ancillary clinical trials.</p>",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "q-6",
         },
         {
            id: 2,
            text: "No",
            target: "r-3",
         },
      ],
      bottom_text:
         "<hr /><i><p>* An ancillary study is an adjunctive or supplemental study to an ongoing study. An ancillary study may or may not be a clinical trial. Determine whether an ancillary study is a clinical trial by answering the four questions that define NIH clinical trials based on the information about the ancillary study alone, regardless of the clinical trial status of the parent trial. An ancillary clinical trial is a trial for which the answer to the four questions is ‘Yes’.</i>",
   },
   {
      id: "q-6",
      question: "Did you take into account only the work being proposed in the ancillary study (not the parent project) while answering all previous questions?",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "r-4",
         },
         {
            id: 2,
            text: "No",
            target: "r-5",
         },
      ],
      bottom_text:
         "<hr /><i><p>* An ancillary study is an adjunctive or supplemental study to an ongoing study. An ancillary study may or may not be a clinical trial. Determine whether an ancillary study is a clinical trial by answering the four questions that define NIH clinical trials based on the information about the ancillary study alone, regardless of the clinical trial status of the parent trial. An ancillary clinical trial is a trial for which the answer to the four questions is ‘Yes’.</i>",
   },/*
   {
      id: "q-7",
      question: "Did you take into account only the work being proposed in the ancillary study (not the parent project) while answering all previous questions?",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "r-4",
         },
         {
            id: 2,
            text: "No",
            target: "r-5",
         },
      ],
   },
   {
      id: "q-8",
      question: "Some NIH career development (K) funding opportunities do not allow for independent clinical trials.",
      top_text:
         "<p>It is important to identify whether NIH considers you to be:</p>" +
         "<ul><li>independently leading a clinical trial -OR-</li><li>gaining research experience by working on a clinical trial led by someone else</li></ul>" +
         "<p>*For application due dates on/after January 25, 2018, identifying whether your study is a clinical trial will be important for:</p>" +
         "<ul><li>which funding opportunity you can respond to</li><li>what information you need to include in the application</li><li>what your responsibilities are with regards to the trial once you receive a grant award</li></ul><h4>Are you</h4></p>",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Working on a clinical trial that is led by another investigator, or for which another investigator has ultimate responsibility?",
            target: "r-6",
         },
         {
            id: 2,
            text: "Independently leading the trial?",
            target: "q-6",
         },
      ],
   },*/
];

var answers = [
   {
      id: "r-1",
      text:
         "<h4>NIH does NOT consider your study to be a clinical trial.</h4>" +
         "<p>Make sure you select a Notice of Funding Opportunity (NOFO) that is NOT specifically for clinical trials.<br/><br/>Find more info about Research involving <a href='/policy-and-compliance/policy-topics/human-subjects' target='_blank'>Human Subjects</a>.",
   },
   {
      id: "r-2",
      text:
         "<h4>Fellowship awards do NOT support independent clinical trials* but do allow research experiences in a clinical trial led by a mentor.</h4>" +
         "<p><strong>Selecting the Correct Notice of Funding Opportunity (NOFO)</strong></p><p>Given that fellowship applications do not support independent clinical trials, specific clinical-trial NOFOs will not exist. However, Section II of the NOFO will clarify that applicants may propose to gain experience in a clinical trial** led by a sponsor/co-sponsor.</p></p>" +
         "<p><strong>What information will you submit?</strong></p>" +
         "<p>Since you are not independently leading a clinical trial, NIH will not be collecting the same detail of information about the clinical trial. Please follow the <a href='https://grants.nih.gov/grants-process/write-application/how-to-apply-application-guide' target='_blank'>application instructions</a> carefully for guidance on which fields you must and must not complete on the PHS Human Subjects and Clinical Trials Information form.</p>" +
         "Information on your role or details about the clinical trial itself must be included in the Research Strategy section of the application. You will also have to ensure your mentor/co-mentor statements address the oversight of the trial." +
         "<hr/><i><p>*An independent clinical trial is one for which the researcher proposing the study has primary or lead responsibility for conducting and executing the trial. NIH policy permits individual career development awardees and individuals appointed to institutional career development awards to be involved in a range of clinical trial activities, including leading independent clinical trials. For NRSA trainees or fellows, however, NIH policy precludes leading an independent clinical trial as part of their training experience. Instead, NRSA trainees and fellows interested in clinical trials may gain clinical trial research experience by working on a trial led by their mentor or another investigator.</p>" +
         "**The involvement of a student, postdoctorate, or early career faculty member in a clinical trial led by their mentor or other investigator, with the goal of obtaining clinical trial experience relevant to their research interests and career goals. A clinical trial research experience is one in which the participant is supervised by a more experienced investigator and is intended to prepare the participant to potentially lead an independent clinical trial in the future. The applicant can be part of the clinical trial team and can use the data generated during the clinical trial research experience in his/her proposed research project. NIH expects the mentor to assume overall responsibility of the trial including registering and reporting in clinicaltrials.gov and obtaining IRB approval.</i>",
   },
   {
      id: "r-3",
      text:
         "<h4>NIH considers your study to be a clinical trial.</h4>" +
         "<p>Applications involving clinical trials must be submitted to a Notice of Funding Opportunity (NOFO) that explicitly states it will accept clinical trials.</p>" +
         "<p>Most NOFOs specify the allowability of clinical trials in the NOFO title with the following designations:</p>" +
         "<ul><li>Clinical Trial Required</li><li>Clinical Trial Optional</li></ul>" +
         "Refer to 'Section II. Award Information' of the NOFO to ensure you are responding to a NOFO that accepts clinical trial applications. (See <a href='https://grants.nih.gov/policy-and-compliance/policy-topics/clinical-trials/specific-funding-opportunities' target='_blank'>here</a> for more information about the types of funding opportunities that allow clinical trials). Follow the <a href='/grants-process/write-application/how-to-apply-application-guide' target='_blank'>application instructions</a> carefully, as well as all NIH <a href='/policy-and-compliance/policy-topics/clinical-trials' target='_blank'>policies</a> related to clinical trial applications and awards.",
   },
   {
      id: "r-4",
      text:
         "<h4>NIH considers your ancillary study to be a clinical trial.</h4>" +
         "<p>Applications involving clinical trials must be submitted to a Notice of Funding Opportunity (NOFO) that explicitly states it will accept clinical trials.</p>" +
         "<p>Most NOFOs specify the allowability of clinical trials in the NOFO title with the following designations:</p>" +
         "<ul><li>Clinical Trial Required</li><li>Clinical Trial Optional</li></ul>" +
         "Please refer to 'Section II. Award Information' of the NOFO to ensure you are responding to a NOFO that accepts clinical trial applications. (See <a href='/policy-and-compliance/policy-topics/clinical-trials/specific-funding-opportunities' target='_blank'>here</a> for more information). Follow the <a href='/grants-process/write-application/how-to-apply-application-guide' target='_blank'>application instructions</a> carefully, as well as all NIH <a href='/policy-and-compliance/policy-topics/clinical-trials' target='_blank'>policies</a> related to clinical trial applications and awards.",
   },
   {
      id: "r-5",
      text:
         "<h4>Please start this decision tool back from the beginning.</h4>" +
         "<p>Remember to take into account only the work being proposed in the ancillary study, not the work being done in the parent project, when answering the questions.</p>",
   },
   {
      id: "r-6",
      text:
         "<h4>You are NOT independently leading a clinical trial.</h4>" +
         "<p><strong>Selecting the Correct NOFO:</strong></p><p>Effective for application <u>due dates on/after January 25, 2018</u>, be sure to select a career development NOFO that does <strong>NOT</strong> require clinical trials. The title of the NOFO will state 'Independent Clinical Trial Not Allowed'. Section II of the NOFO will indicate that applicants may propose to gain experience in a clinical* trial led by a mentor/co-mentor as part of their career development.</p>" +
         "<p><strong>What information will you submit?</strong></p><p>Because NIH does not consider you to be independently leading the trial, we will not be collecting the same detail of information. Your application will not be subject to the same review criteria as an application in which you would be leading the clinical trial.</p>" +
         "<p>Please follow the <a href='/grants-process/write-application/how-to-apply-application-guide' target='_blank'>application instructions</a> carefully. They explicitly state that you should only use the PHS Human Subjects and Clinical Trials Information form (included in the application package associated with the NOFO to which you are responding) to provide information on the human subjects aspects of your application.</p>" +
         "<p>Information on your role or details about the clinical trial itself must be included in the Research Strategy section of the application. The fields on the PHS Human Subjects and Clinical Trials Information form for clinical trials are reserved for information collection related to independent clinical trials**.</p><p>You will also have to ensure your mentor/co-mentor statements address the oversight of the trial.</p></p>" +
         "<hr/><i><p>* The involvement of a student, postdoctorate, or early career faculty member in a clinical trial led by their mentor or other investigator, with the goal of obtaining clinical trial experience relevant to their research interests and career goals. A clinical trial research experience is one in which the participant is supervised by a more experienced investigator and is intended to prepare the participant to potentially lead an independent clinical trial in the future. The applicant can be part of the clinical trial team and can use the data generated during the clinical trial research experience in his/her proposed research project. NIH expects the mentor to assume overall responsibility of the trial including registering and reporting in clinicaltrials.gov and obtaining IRB approval.</p>" +
         "** An independent clinical trial is one for which the researcher proposing the study has primary or lead responsibility for conducting and executing the trial. NIH policy permits individual career development awardees and individuals appointed to institutional career development awards to be involved in a range of clinical trial activities, including leading independent clinical trials. For NRSA trainees or fellows, however, NIH policy precludes leading an independent clinical trial as part of their training experience. Instead, NRSA trainees and fellows interested in clinical trials may gain clinical trial research experience by working on a trial led by their mentor or another investigator.</i>",
   },
   {
      id: "r-404",
      text: "<h3>Error</h3><p>You have found a route that is not mapped to a result. Please fix your app logic.",
   },
];

export { questions, answers };
